import { styled, Tooltip, tooltipClasses } from "@mui/material";

export const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#D3D3D3",
      color: '#000',
      boxShadow: theme.shadows[1],
      fontSize: "1rem",
      whiteSpace: "pre-wrap"
    },
  }));